/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowinputrefine3Inputs */

const en_aiflowinputrefine3 = /** @type {(inputs: Aiflowinputrefine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should change in this variant?`)
};

const de_aiflowinputrefine3 = /** @type {(inputs: Aiflowinputrefine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll an der Variante anders werden?`)
};

/**
* | output |
* | --- |
* | "What should change in this variant?" |
*
* @param {Aiflowinputrefine3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowinputrefine3 = /** @type {((inputs?: Aiflowinputrefine3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowinputrefine3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowinputrefine3(inputs)
	return de_aiflowinputrefine3(inputs)
});
export { aiflowinputrefine3 as "aiFlowInputRefine" }